import { getMetadataFieldValue } from 'automation-ui-action-features/actions/extension/utils/getMetadataFieldValue';
export const getMetadataFieldsKey = metadataFields => metadataFields.reduce((acc, {
  fieldKey,
  fieldValue
}) => {
  const hashString = `${fieldKey}:${getMetadataFieldValue(fieldValue)}`;
  return acc ? `${acc}-${hashString}` : hashString;
}, '') || undefined; // Prefer undefined over empty string.